import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';
import { StudentCoursesService } from '@edtech-ui/core/services/student-courses/student-courses.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-student-navbar-quiz-lesson',
	standalone: true,
	imports: [MatToolbarModule, RouterModule, CommonModule,HasPermissionDirective],
	templateUrl: './student-navbar-quiz-lesson.component.html',
	styleUrl: './student-navbar-quiz-lesson.component.scss'
})
export class StudentNavbarQuizLessonComponent implements OnInit, OnDestroy {

	@Output() openSidebar = new EventEmitter<void>();

	courseTitle = '';
	private sub = new Subscription();
	PermissionForStudents = PermissionForStudents;

	constructor(private _studentCourseService: StudentCoursesService) { }

	ngOnInit(): void {
		this.sub.add(
			this._studentCourseService.courseDetails$.subscribe(details => {
				if (details) this.courseTitle = details.course_title || '';
			})
		);
	}

	triggerOpenSidebar() {
		this.openSidebar.emit();
	}

	ngOnDestroy(): void {
		this.sub.unsubscribe();
	}

}
